export const SocketEvents = {
  Connect: 'connect',
  Notifications: 'notifications',
  NewNotification: 'new_notification',
  GetNotifications: 'get_notifications',
  ApplicationError: 'application_error',
  ConnectError: 'connect_error',
  Disconnect: 'disconnect'
};